import { render, staticRenderFns } from "./geboortelijst.vue?vue&type=template&id=9ad7f4dc&"
import script from "./geboortelijst.vue?vue&type=script&lang=js&"
export * from "./geboortelijst.vue?vue&type=script&lang=js&"
import style0 from "./geboortelijst.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports